// react core
import { useContext } from "react";

// date handling
import dayjs from "dayjs";

// material design
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";

// entzy context
import configEntzy from "components/config/ConfigEntzy";
import { EventContext } from "components/event/EventContext";
// import { TextTag } from "components/utils/common/CommonTags";

// entzy components
import ActionMessagingSettings from "./ActionMessagingSettings";

// entzy assets
// import bgTileRooms from "assets/tiles/bots-t25.png";

// fonts and colors
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSidebar as iconSideRooms } from "@fortawesome/pro-duotone-svg-icons";
// import { faTimes as iconClose } from "@fortawesome/pro-light-svg-icons";
// import { faDoNotEnter as iconDisabled } from "@fortawesome/pro-duotone-svg-icons";
import { faPortalEnter as iconEnterRoom } from "@fortawesome/pro-solid-svg-icons";
import { faArrowRight as iconArrowRight } from "@fortawesome/pro-solid-svg-icons";

function RoomMessagingSelector(props) {
  // const user = props.user;
  const handleCloseAction = props.handleCloseAction;

  const eventContext = useContext(EventContext);

  const visibleRooms = Object.keys(eventContext.state.messaging.rooms).filter(
    (key) =>
      !key.startsWith("ai") &&
      !(
        (key.includes("runner") && !eventContext.state.event.manager) ||
        (key.includes("rider") && eventContext.state.event.manager)
      ),
  );
  // move front desk to the front
  const deskIndex = visibleRooms.indexOf("desk");
  if (deskIndex > -1) {
    visibleRooms.splice(deskIndex, 1);
    visibleRooms.unshift("desk");
  }

  // side rooms for launched dates
  // format of side room keys: [roomName]|[dateKey]
  const visibleDateRooms = Object.keys(eventContext.state.messaging.rooms)
    .filter(
      (key) =>
        key.includes("|") &&
        !(
          (key.includes("runner") && !eventContext.state.event.manager) ||
          (key.includes("rider") && eventContext.state.event.manager)
        ),
    )
    .map((key) => {
      return {
        roomName: key,
        parentRoomName: key.split("|")[0],
        isMainSideRoom: key.split("|")[0] === "main",
        dateKey: key.split("|")[1],
        dateDisplay: dayjs(key.split("|")[1]).format("ddd DD MMM YYYY"),
      };
    });

  // loop over visible rooms and visible date keys to create array of date rooms visibleDateRooms
  // date rooms are objects {roomName, dateKey, roomDateName}
  // desk is excluded

  // const [showDateRooms, setShowDateRooms] = useState(false);

  // const handleShowDateRooms = () => {
  //   setShowDateRooms(!showDateRooms);
  // };
  // const handleSelectDateRoom = (dateKey) => {
  //   let sideRoomName = eventContext.state.messaging.activeRoom.split("|")[0];
  //   if (dateKey !== null) {
  //     sideRoomName += "|" + dateKey;
  //   }
  //   eventContext.setMessageRoom(sideRoomName);
  //   // setShowDateRooms(false);
  // };

  return (
    <Box className="box-default">
      <Box
        className="box-default"
        // sx={{
        //   borderRadius: configEntzy.BORDER_SIZE_XL,
        //   py: configEntzy.APP_SPACING_MD2X,
        //   px: configEntzy.APP_SPACING_MD2X,
        //   // backgroundImage: `url(${bgTileRooms})`,
        //   // backgroundRepeat: "repeat",
        //   // backgroundSize: "auto",
        // }}
      >
        <Box className="box-default">
          {/* {eventContext.state.messaging.activeSideRoom ? (
            <Box className="box-default">
              <Box className="box-default">
                <Typography variant="subtitle2" color="primary">
                  SELECTED
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ mt: configEntzy.APP_SPACING_MD }}
                >
                  <TextTag
                    size="md"
                    rounded={true}
                    bgColor="primary.main"
                    color="black"
                    text={
                      <span
                        style={{
                          backgroundColor: "orange",
                          color: "black",
                          padding: "2px",
                          borderRadius: "10px",
                        }}
                      >
                        <span>&nbsp;&nbsp;</span>
                        {dayjs(
                          eventContext.state.messaging.activeSideRoom,
                        ).format("ddd DD MMM YYYY")}
                        <span>&nbsp;&nbsp;</span>
                      </span>
                    }
                  />
                </Typography>
              </Box>
              <Box
                className="box-default"
                sx={{
                  pt: configEntzy.APP_SPACING_MD3X,
                }}
              >
                <TextTag
                  size="md"
                  rounded={true}
                  bgColor="white"
                  color="black"
                  text={
                    <span>
                      <span>&nbsp;&nbsp;</span>
                      <span>Exit Side Room</span>
                      <span>&nbsp;&nbsp;</span>
                    </span>
                  }
                  textNoCasing={true}
                  noMask={true}
                  onClick={() => {
                    handleSelectDateRoom(null);
                  }}
                />
              </Box>
            </Box>
          ) : (
          )} */}
          <Box className="box-default text-paragraph">
            <Typography variant="subtitle2" color="primary">
              <span>
                <span>Side Rooms by Launch Date</span>
                <span>&nbsp;</span>
                <span>({visibleDateRooms.length})</span>
              </span>
            </Typography>
            <Typography variant="body1" color="white">
              Chat to members matched on specific dates
            </Typography>
            {visibleDateRooms.length === 0 && (
              <Typography
                variant="body1"
                sx={{
                  mt: configEntzy.APP_SPACING_MD3X,
                  mb: configEntzy.APP_SPACING_MD2X,
                }}
              >
                No launched dates yet
              </Typography>
            )}
          </Box>
        </Box>

        <Collapse
          in={
            // showDateRooms &&
            // !eventContext.state.messaging.activeRoom.includes("desk") &&
            visibleDateRooms.length > 0
          }
          timeout={{
            enter: configEntzy.TRANSITIONS.fast,
            exit: configEntzy.TRANSITIONS.default,
          }}
        >
          <Box
            className="box-default"
            sx={{ mt: configEntzy.APP_SPACING_MD2X }}
          >
            {visibleDateRooms.map((dateRoom, index) => {
              return (
                <Box
                  key={dateRoom.roomName}
                  className="box-default bg-black-t50"
                  sx={{
                    mb: configEntzy.APP_SPACING_SM,
                    borderRadius: configEntzy.BORDER_SIZE_XL,
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor:
                      eventContext.state.messaging.activeRoom ===
                      dateRoom.roomName
                        ? "darkorange"
                        : "transparent",
                  }}
                >
                  <Box className="box-default flex-center half-width">
                    <ActionMessagingSettings
                      {...props}
                      roomName={dateRoom.roomName}
                      source="selector"
                      viewer={
                        eventContext.state.event.manager ? "runner" : "rider"
                      }
                    />
                  </Box>
                  <Box
                    className="box-default half-width text-left action-pointover"
                    sx={{
                      py: configEntzy.APP_SPACING_MD,
                      px: configEntzy.APP_SPACING_MD,
                      borderTopRightRadius: configEntzy.BORDER_SIZE_XL,
                      borderBottomRightRadius: configEntzy.BORDER_SIZE_XL,
                      borderLeft: "1px solid black",
                    }}
                    onClick={() => {
                      eventContext.setMessageRoom(dateRoom.roomName);
                      handleCloseAction();
                    }}
                  >
                    <Typography variant="subtitle2" color="primary.dark">
                      {dateRoom.dateDisplay}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="grey.500"
                      className="proper-case"
                    >
                      {dateRoom.isMainSideRoom
                        ? "Everyone on this date"
                        : `${dateRoom.parentRoomName}s on this date`}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="grey.400"
                      className="upper-case"
                      sx={{ mt: configEntzy.APP_SPACING_SM }}
                    >
                      {eventContext.state.messaging.activeRoom ===
                      dateRoom.roomName ? (
                        <span
                          className="bg-orange"
                          style={{
                            padding: "2px 8px",
                            borderRadius: "12px",
                            color: "black",
                          }}
                        >
                          Active Room
                        </span>
                      ) : (
                        <span>
                          <span>Open Room</span>
                          <span>&nbsp;&nbsp;</span>
                          <FontAwesomeIcon icon={iconArrowRight} />
                          <FontAwesomeIcon icon={iconEnterRoom} />
                        </span>
                      )}
                    </Typography>
                  </Box>
                </Box>
              );
            })}

            {eventContext.state.event.calendar.dates.launched.all.keys
              .length === 0 && (
              <Box
                className="box-default"
                sx={{
                  pb: configEntzy.APP_SPACING_MD,
                }}
              >
                <Typography variant="subtitle1" className="content-disabled">
                  <em>No launch dates</em>
                </Typography>
              </Box>
            )}
          </Box>
        </Collapse>
      </Box>
      <Box
        className="box-default text-paragraph"
        sx={{
          mt: configEntzy.APP_SPACING_MD,
          px: configEntzy.APP_SPACING_MD2X,
        }}
      >
        <Typography variant="body1">
          <em>
            Side rooms are created automatically when dates trigger and only
            matched members can join. They expire{" "}
            {configEntzy.MSG_SIDE_ROOMS_HISTORY_DAYS} days after launch date.
          </em>
        </Typography>
      </Box>
    </Box>
  );
}

export default RoomMessagingSelector;
